import { TVehicle } from "types";

interface IMarkeReducer {
  vehicles: TVehicle[];
  filter: any;
}

const MarkeReducer = ({ vehicles, filter }: IMarkeReducer) => {
  if (!(filter.marke && filter.marke.length)) return vehicles;
  const {
    modell: modellFilter,
    marke: markeFilter,
    modell_gruppe: modellGruppeFilter,
  } = filter;
  return vehicles.filter(({ modell }) => {
    return (
      modellFilter.includes(modell.id) ||
      markeFilter.includes(modell.marke?.id) ||
      modellGruppeFilter.includes(modell.modell_gruppe?.id)
    );
  });
};

export default MarkeReducer;
